<template>
    <v-container fluid>
    <field-form id="pfid1618852457" v-if="item" @save="save" :saving="saving" :wizard="wizard" :wizardSteps="currentWizard" :step="displayStep" :last-editable-step="lastEditableStep" :allow-editable="true" @cancel="cancelWizard()" @click-step="changeStep">
    <v-card id="pfid1618667211" class="mb-5">
    <v-card-title>{{$t('campaigns.name.title')}}</v-card-title>
    <v-card-text><span>{{$t('campaigns.name.text')}}</span>
    <v-text-field id="pfid1618852463" dense v-model="fields.name" :placeholder="$t('campaigns.name.title')" :rules="[v=> !!v || $t('form.rules.required')]"></v-text-field>
    </v-card-text>
    </v-card>
    <template v-if="!isSwu">
    <h4 class="text-h4">{{$t('campaigns.segment.title')}}</h4>
    <p>{{$t('campaigns.segment.text')}}</p>
    <v-row id="pfid1618667101" justify="space-between">
      <v-col cols="12" md="6" lg="3" v-for="t in segmentationTypes" :key="t.value">
      <v-card link :disabled="!t.active || t.disabled" :color="segmentationType == t.value ? 'primary' : null" :dark="segmentationType == t.value" 
       height="100%" @click="setSegmentationType(t.value)">
          <v-badge overlap tile v-if="!t.active" color="success" :content="$t('common.comingSoon')"></v-badge>
          <v-card-title color="primary">{{t.title}}</v-card-title>
          <v-card-text>{{t.text}}</v-card-text>
        </v-card>
        </v-col>
    </v-row>
    <v-row>
    <v-col>
    <v-card height="100%" v-if="hasSegmentationParams">
      <v-card-title>{{$t('campaigns.segment.setup')}}</v-card-title>
      <v-card-text>
      <v-row no-gutters justify="start" align="center">
        <div class="mr-3">{{ segmentText[0] }}</div>
        <v-select style="max-width:200px"
        v-model="evalPeriodType"
        :items="evaluationPeriodTypes"
        />
        <div class="mx-3"> {{$t('common.intervals.from')}} </div>
        <v-text-field id="pfid1618667006" style="max-width:150px" v-model.number="segmentFrom" :placeholder="$t('common.intervals.unbound')" :label="segmentText[1]" type="number" :suffix="segmentSuffix" /> 
        <div class="mx-3"> {{$t('common.intervals.to')}} </div>
        <v-text-field id="pfid1618667011" style="max-width:150px" v-model.number="segmentTo" :placeholder="$t('common.intervals.unbound')" :label="segmentText[2]" type="number" :suffix="segmentSuffix"/> 
        <div class="ml-3"> {{$t('common.intervals.included')}} </div>
      </v-row>
      </v-card-text>
    </v-card>
    <v-card height="100%" v-if="hasTagSelection">
      <v-card-title>{{$t('campaigns.segment.tag.setup')}}</v-card-title>
      <v-card-text>
      <!--<tag-selector v-model="tag" :domain="item.domainID" />-->
      <tag-autocomplete v-model="tag" :domain="item.domainID" />
      <v-switch
        v-model="tagInverse"
        :label="$t('campaigns.segment.tag.inverse')"
        class="mt-3"
      />
      </v-card-text>
    </v-card>
    </v-col>
    <v-col cols="12" lg="3" v-if="evalPeriodType == 'custom'">
    <v-card id="pfid1618667147">
    <v-card-title>{{$t('campaigns.segment.evaluationPeriod.title')}}</v-card-title>
    <v-list>
          <v-list-item>
            <v-list-item-icon><v-icon>$calendarFrom</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{$t('common.intervals.from')}}</v-list-item-title>
              <v-list-item-subtitle>{{ formatDate(fields.evaluationPeriod.from, true) }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-menu offset-y top :close-on-content-click="false" v-model="evalPeriodMenuFrom">
              <template v-slot:activator="{ on, attrs }">
               <!-- action button cannot be used because tooltip collides with the menu -->
               <v-btn id="pfid1618667189" v-on="on" v-bind="attrs" icon color="primary"><v-icon>$calendarChoose</v-icon></v-btn>
              </template>
                <v-date-picker
                  id="pfid1618852560" 
                  v-model="evalPeriodFrom"
                  @input="evalPeriodMenuFrom = false"
                ></v-date-picker>
      </v-menu>
              
            </v-list-item-action>
          </v-list-item>
          <v-list-item>
            <v-list-item-icon><v-icon>$calendarTo</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{$t('common.intervals.to')}}</v-list-item-title>
              <v-list-item-subtitle>{{ formatDate(fields.evaluationPeriod.to, true) }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-menu offset-y top :close-on-content-click="false" v-model="evalPeriodMenuTo">
              <template v-slot:activator="{ on, attrs }">
               <!-- action button cannot be used because tooltip collides with the menu -->
               <v-btn id="pfid1618667240" v-on="on" v-bind="attrs" icon color="primary"><v-icon>$calendarChoose</v-icon></v-btn>
              </template>
                <v-date-picker
                  v-model="evalPeriodTo"
                  @input="evalPeriodMenuTo = false"
                ></v-date-picker>
      </v-menu>
              
            </v-list-item-action>
          </v-list-item>
        </v-list>
    <!--
    <v-card-text v-else>
      <v-alert colored-border border="left"  type="warning">
        {{$t('campaigns.segment.evaluationPeriod.error')}}
      </v-alert>
    </v-card-text>
    -->
    <v-card-actions>
      
    </v-card-actions>
    </v-card>
    </v-col>
    </v-row>
    </template>
    <template v-else>
      <!-- SPECIAL SMART WARM UP SETTINGS -->
      <h4 class="text-h4">{{$t('campaigns.segment.swu.title')}}</h4>
      <p>{{$t('campaigns.segment.swu.subtitle')}}</p>
    <v-row>
      <v-col>
        <v-card height="100%">
        <v-card-title>{{$t('campaigns.segment.swu.setup')}}</v-card-title>
        <v-card-text>
        <v-row no-gutters justify="start"  align="center">
          <div class="mr-3"> {{$t('campaigns.segment.swu.text[0]')}} </div>
          <v-text-field id="pfid1618667006" style="max-width:150px" v-model.number="swuCount" 
          :rules="[v=> (v > 0 && v <= 3000) || $t('form.rules.swu.count')]"
          placeholder="1000" :label="$t('campaigns.segment.swu.count')" type="number" :suffix="segmentSuffix" /> 
          <div class="mx-3"> {{$t('campaigns.segment.swu.text[1]')}} </div>
        </v-row>
        <v-row no-gutters justify="start"  align="center">
          <div class="mr-3"> {{$t('campaigns.segment.swu.text[2]')}} </div>
          <v-text-field id="pfid1618667011" style="max-width:150px" v-model.number="swuDuration" 
          :rules="[v=> (v > 0 && v <= 21) || $t('form.rules.swu.length')]"
          placeholder="14" :label="$t('campaigns.segment.swu.length')" type="number" :suffix="segmentSuffix"/> 
          <div class="ml-3"> {{$t('campaigns.segment.swu.text[3]')}} </div>
        </v-row>
      </v-card-text>
      <v-card-title>{{$t('campaigns.segment.tag.setup')}}</v-card-title>
        <v-card-text>
          <tag-autocomplete v-model="tag" :domain="item.domainID" />
        </v-card-text>
    </v-card>
    </v-col>
   
    <v-col cols="12" lg="8">
    
      <swu-preview-chart
        id="pfid1643388559" 
        :label="$t('campaigns.segment.swu.chart.title')"
        :xaxis="xaxis"
        :series="sentDays"
        :height="375"
        :chartHeight="275"
        />
      <!--
      <sent-card
        id="pfid1643388559" 
        dark 
        :height="280"
        :chart-height="180"
        :label="$t('campaigns.detail.stats.sent')"
        :value="swuCount"
        :count-suffix="$t('dashboard.messages.suffix')"
        :loading="loading"
        :xaxis="xaxis"
        :series="sentDays"
      />
      -->
    </v-col>
      </v-row>
    </template>
    <confirm-dialog title="dialog.unsaved.title" button-caption="dialog.leave" v-model="leaveDialog" @confirm="confirmLeave(true)" @cancel="confirmLeave(false)">
          {{$t('dialog.unsaved.text')}}
    </confirm-dialog>
    </field-form>
    <v-skeleton-loader v-else type="card,card,card" />
    </v-container>
</template>
<script>

  import EntityForm from "@/mixins/entity-form"
  import Wizards from "@/mixins/wizards"
  import Formatters from "@/mixins/formatters"
  import ConfirmLeave from '@/mixins/confirm-leave'
  import SwuPreviewChart from '@/components/SwuPreviewChart'
  //import TagSelector from '@/components/TagSelector'
  import TagAutocomplete from '@/components/TagAutocomplete'
  
  //import { mapState } from 'vuex'

  export default {
    mixins: [ConfirmLeave, EntityForm, Wizards, Formatters],
    components: {SwuPreviewChart, /*TagSelector,*/ TagAutocomplete},
    name: 'Segment',
    data() {
      return {
        endpoint: 'campaigns',
        segmentationType: this.isWelcome ? 'TAG' : null,
        evalPeriodType: null,
        segmentFrom: 0,
        segmentTo: null,
        evalPeriodFrom: null,
        evalPeriodTo: null,
        evalPeriodMenuFrom: false,
        evalPeriodMenuTo: false,
        swuCount: 1000,
        swuDuration: 14,
        tag: null,
        fields: {
          name: null,
          segmentationType: null,
          segment: null,
          evaluationPeriod: null
        }
      };
    },
    computed: {
      wizardParams() {
        let p = {
        };
        if(this.item) {
          p.medium = this.item.medium?.toLowerCase() || 'email';
        }
        return p;
      },
      segmentSuffix() {
        return this.segmentationType == 'AMOUNT_SPENT' ? this.formatCurrency(this.item?.domain.currency, true) : null;
      },
      segmentationTypes() {
        return [
          {title: this.$t('campaigns.segmentationTypes.all.title'), text: this.$t('campaigns.segmentationTypes.all.text'), value: 'ALL', active: true, disabled: this.isWelcome },
          {title: this.$t('campaigns.segmentationTypes.ordersCount.title'), text: this.$t('campaigns.segmentationTypes.ordersCount.text'), value: 'ORDER_COUNT', active: true, disabled: this.isWelcome },
          {title: this.$t('campaigns.segmentationTypes.amountSpent.title'), text: this.$t('campaigns.segmentationTypes.amountSpent.text'), value: 'AMOUNT_SPENT', active: true, disabled: this.isWelcome },
          {title: this.$t('campaigns.segmentationTypes.tag.title'), text: this.$t('campaigns.segmentationTypes.tag.text'), value: 'TAG', active: true },
          //{title: this.$t('campaigns.segmentationTypes.rfm.title'), text: this.$t('campaigns.segmentationTypes.rfm.text'), value: 'RFM', active: false }
        ]
      },
      evaluationPeriodTypes() {
        let v = ['7d','14d','1m','3m','6m','12m'].map(value => { return { text: this.$t(`common.periods.${value}`), value }});
        /*
        let v = [
          { text: 'Last 7 days', value: '7d'},
          { text: 'Last 14 days', value: '14d'},
          { text: 'Last 1 month', value: '1m'},
          { text: 'Last 3 months', value: '3m'},
          { text: 'Last 6 months', value: '6m'},
          { text: 'Last year', value: '12m'},
        ];
        */
        if(this.item.scheduleType == 'SCHEDULED') {
          v = v.concat({ text: this.$t('common.periods.fixed'), value: 'custom'});
        }
        return v;
      },
      hasSegmentationParams() {
        return this.segmentationType && this.segmentationType != 'ALL' && this.segmentationType != 'TAG';
      },
      hasTagSelection() {
        return this.segmentationType && this.segmentationType == 'TAG';
      },
      segmentText() {
        if(this.fields.segmentationType == 'ORDER_COUNT') {
          return [
            this.$t('campaigns.segment.parameters.orderCount[0]'),
            this.$t('campaigns.segment.parameters.orderCount[1]'),
            this.$t('campaigns.segment.parameters.orderCount[1]') 
          ];
        } else {
          return [
            this.$t('campaigns.segment.parameters.amountSpent[0]'),
            this.$t('campaigns.segment.parameters.amountSpent[1]'),
            this.$t('campaigns.segment.parameters.amountSpent[1]') 
          ];
        }
      },
      isSwu() {
        return this.item?.scheduleType == 'SMART_WARM_UP';
      },
      isWelcome() {
        return this.item?.scheduleType == 'WELCOME';
      },
      xaxis() {
        return Array(this.swuDuration + 2).fill('').map((s,i) => {
          let d = new Date();
          d.setDate(d.getDate() + i);
          return d.toISOString().substring(0,10)+'T00:00:00.000Z';
         });
      },
      sentDays() {
        return [0, ...this.getBatches(this.swuCount, this.swuDuration, 10), 0];
      }
    },
    watch: {
        item() {
          this.setFields();
        },
        evalPeriodFrom(val) {
          if(!this.fields.evaluationPeriod){
            this.fields.evaluationPeriod = {};
          }
          this.fields.evaluationPeriod.from = new Date(val);
        },
        evalPeriodTo(val) {
          if(!this.fields.evaluationPeriod){
            this.fields.evaluationPeriod = {};
          }
          this.fields.evaluationPeriod.to = new Date(val);
        }
    },
    methods: {
      setSegmentationType(type) {
        this.segmentationType = type;
        if(type == 'ALL') {
          this.fields.segmentationType = 'ORDER_COUNT';
          this.fields.segment = { from: 0 };
          this.segmentFrom = 0;
          this.segmentTo = null;
          this.evalPeriodType = '7d';
        }/* else if(type == 'TAG') {
          this.$store.dispatch('contacts/listTags');
          this.fields.segmentationType = type;
        } */ else {
          this.fields.segmentationType = type;
        }
      },
      setFields() {
          if(!this.item) {
            return;
          }
          // set util variables
          if(this.item.evaluationPeriod?.window) {
            this.evalPeriodType = this.item.evaluationPeriod.window;
          } else if(this.item.evaluationPeriod) {
            this.evalPeriodType = 'custom';
          }
          if(this.item.segmentationType) {
            if(this.item.segmentationType == 'ORDER_COUNT' && this.item.segment?.from === 0 && this.item.segment?.to === null) {
              this.segmentationType = 'ALL';
            } else {
              this.segmentationType = this.item.segmentationType;
            }
          } else if(this.isWelcome) {
            // new welcome campaign - preselect tag
            this.segmentationType = 'TAG';
          }
          if(this.item.segment?.from) {
            this.segmentFrom = this.item.segment.from;
          }
          if(this.item.segment?.to) {
            this.segmentTo = this.item.segment.to;
          }
          if(this.item.evaluationPeriod?.from) {
            this.evalPeriodFrom = this.item.evaluationPeriod.from.substring(0,10);
          }
          if(this.item.evaluationPeriod?.to) {
            this.evalPeriodTo = this.item.evaluationPeriod.to.substring(0,10);
          }
          if(this.item.segment?.count) {
            this.swuCount = this.item.segment?.count;
          }
          if(this.item.segment?.duration) {
            this.swuDuration = this.item.segment?.duration;
          }
          if(this.item.segment?.tagId) {
            this.tag = this.item.segment?.tagId
          }
          if(this.item.segment?.inverse) {
            this.tagInverse = this.item.segment?.inverse
          }
      },
      prepareFields() {
        
        if(this.evalPeriodType) {
          if(!this.fields.evaluationPeriod) {
            this.fields.evaluationPeriod = {};
          }
          if(this.evalPeriodType == 'custom') {
            this.fields.evaluationPeriod.from = this.evalPeriodFrom ? new Date(this.evalPeriodFrom) : null;
            this.fields.evaluationPeriod.to = this.evalPeriodTo ? new Date(this.evalPeriodTo) : null;
            this.fields.evaluationPeriod.window = 'custom';
          } else {
            this.fields.evaluationPeriod.window = this.evalPeriodType;
          }
        }
        if(this.fields.segmentationType && this.fields.segmentationType != 'TAG') {
          this.fields.segment = { from: this.segmentFrom === '' ? null : this.segmentFrom, to: this.segmentTo === '' ? null: this.segmentTo }
        } else if(this.fields.segmentationType == 'TAG') {
          this.fields.segment = { tagId: this.tag, inverse: this.tagInverse }
          this.fields.evaluationPeriod = {}; // just to have something here
        }
        if(this.isSwu) {
          this.fields.segment = { duration: this.swuDuration, count: this.swuCount, tagId: this.tag }
        }
        
        let validation = true;
        let notificationText = [];
        
        if(!this.segmentationType && !this.isSwu) {
          validation = false;
          notificationText.push(this.$t('campaigns.segment.setup'));
        } else if(this.segmentationType && this.segmentationType == 'TAG' && !this.fields.segment?.tagId) {
          validation = false;
          notificationText.push(this.$t('campaigns.segment.parameters.title'))          
        } else if(this.segmentationType && this.segmentationType != 'ALL' && this.segmentationType != 'TAG'  && !(this.fields.segment?.from || this.fields.segment?.to)) {
          validation = false;
          notificationText.push(this.$t('campaigns.segment.parameters.title'))
        }

        if(this.segmentationType &&
        !(this.segmentationType == 'TAG' || this.fields.evaluationPeriod?.window || (this.fields.evaluationPeriod?.from && this.fields.evaluationPeriod?.to))) {
          validation = false;
          notificationText.push(this.$t('campaigns.segment.evaluationPeriod.title'));
        }

        if(this.isSwu && !(this.fields.segment?.duration && this.fields.segment?.count)) {
          validation = false;
          notificationText.push(this.$t('campaigns.segment.swu.setup'));
        }

        if(!validation) {
          this.$store.dispatch('ui/notify', { error: true, text: this.$t('form.errors.fillIn', {errors: notificationText.join(this.$t('form.errors.joinClause'))})})
        }
        return validation;
      },
      getBatches(count, duration, startBatch) {
        // copied from amplify/backend/function/dreamroisegmenthandler/src/index.js
        let b = [];
        let avgb = count/duration;
        let step = (avgb-startBatch)/(duration/2);
        for(let i = 0; i < duration; i++) {
        // late night work - might be simplified?
          let limit = Math.round(avgb + step * (i - (duration/2) + Math.floor(i / (duration / 2))));
          b.push(Math.max(limit,0));
        }
        return b;
      }
    },
    created() {
      this.$store.commit('ui/wizard', {value: true });
      this.setLastEditableStep();
      this.setFields();
    }
  }
</script>